import type { ApolloClient } from "@apollo/client";
import { assertBrandId, assertPresence } from "utils/assertions";
import { gql } from "__generated__/gql";
import makeGetSignedPutUrl from "./signedPutUrl";

const mutation = gql(/* GraphQL */ `
  mutation SignedPutUrlForBrand(
    $brandId: UUID!
    $filePath: String
    $file: SignedPutUrlFileInput!
    $metadata: [SignedPutUrlInputMetadataPair!]
  ) {
    signedPutUrlForBrand(
      input: {
        brandId: $brandId
        filePath: $filePath
        file: $file
        metadata: $metadata
      }
    ) {
      url
      key
    }
  }
`);

export default function makeGetSignedPutUrlForBrand(
  client: ApolloClient<object>,
  brandId: UUID | null | undefined,
) {
  return makeGetSignedPutUrl(client, async (variables) => {
    assertBrandId(brandId);

    const { data } = await client.mutate({
      mutation,
      variables: {
        ...variables,
        brandId,
      },
    });
    assertPresence(
      data?.signedPutUrlForBrand,
      "Could not get signed URL from response!",
    );
    return data.signedPutUrlForBrand;
  });
}
